import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ClientesList from '../../components/clientes/ClientesList';
import ClienteDetail from '../../components/clientes/ClienteDetail';

const ClientesPage: React.FC = () => {
  return (
    <Routes>
      <Route index element={<ClientesList />} />
      <Route path=":id" element={<ClienteDetail />} />
    </Routes>
  );
};

export default ClientesPage;